import React from "react";
import "./preLoader.css";
import Profile from "./assets/images/mf-avatar.svg";

const Preloader = ({ name }) => {
  return (
    <div className="preloader">
      <div className="loader">
        <h1 className="name">
          <img src={Profile} alt="Mohanraj Murugesan" />
          &nbsp;&nbsp;{name}
        </h1>
      </div>
    </div>
  );
};

export default Preloader;
